const LOCAL_PRODUCTS = [
  {
    id: "ts-03",
    sku: "TS-03",
    name: "Tee, 3-pack",
    price: 20,
    image: "images/ts-03.svg",
    genders: ["male", "female"],
    collection: "tees",
    tags: ["tee", "t-shirt", "tshirt", "shirt", "top", "pack", "3 pack", "cotton", "everyday", "basic"],
    blurb: "Three everyday tees. Soft cotton, boxy cut.",
  },
  {
    id: "ls-03",
    sku: "LS-03",
    name: "Long sleeve",
    price: 28,
    image: "images/ls-03.svg",
    genders: ["male", "female"],
    collection: "longsleeves",
    tags: ["long sleeve", "crew", "layer", "cold", "shirt", "top", "cotton"],
    blurb: "Heavyweight long sleeve for layering.",
  },
  {
    id: "hd-03",
    sku: "HD-03",
    name: "Zip hoodie",
    price: 48,
    image: "images/hd-03.svg",
    genders: ["male", "female"],
    collection: "hoodies",
    tags: ["hoodie", "zip", "zip up", "sweatshirt", "hood", "warm", "layer"],
    blurb: "Full-zip hoodie with a quiet drape.",
  },
  {
    id: "wb-01",
    sku: "WB-01",
    name: "Windbreaker",
    price: 55,
    image: "images/wb-01.svg",
    genders: ["male", "female"],
    collection: "outerwear",
    tags: ["windbreaker", "jacket", "rain", "shell", "outerwear", "weather", "zip", "hood"],
    blurb: "Light shell for rain and wind.",
  },
  {
    id: "sh-01",
    sku: "SH-01",
    name: "Shorts",
    price: 22,
    image: "images/sh-01.svg",
    genders: ["male", "female"],
    collection: "bottoms",
    tags: ["shorts", "summer", "bottoms", "hot weather", "drawstring"],
    blurb: "Easy shorts with a drawcord.",
  },
  {
    id: "sp-06",
    sku: "SP-06",
    name: "Sweatpants",
    price: 40,
    image: "images/sp-06.svg",
    genders: ["male", "female"],
    collection: "bottoms",
    tags: ["sweatpants", "joggers", "pants", "lounge", "warm", "bottoms"],
    blurb: "Tapered sweatpants, elastic cuff.",
  },
  {
    id: "pt-04",
    sku: "PT-04",
    name: "Cargo pants",
    price: 52,
    image: "images/pt-04.svg",
    genders: ["male", "female"],
    collection: "bottoms",
    tags: ["cargo", "pants", "trousers", "pockets", "utility", "bottoms"],
    blurb: "Straight cargo with side pockets.",
  },
  {
    id: "pt-05",
    sku: "PT-05",
    name: "Jeans",
    price: 58,
    image: "images/pt-05.svg",
    genders: ["male", "female"],
    collection: "bottoms",
    tags: ["jeans", "denim", "pants", "trousers", "everyday", "bottoms"],
    blurb: "Washed black denim, straight leg.",
  },
  {
    id: "tt-06",
    sku: "TT-06",
    name: "Tank, 3-pack",
    price: 18,
    image: "images/tt-06.svg",
    genders: ["male", "female"],
    collection: "tees",
    tags: ["tank", "sleeveless", "vest", "pack", "3 pack", "summer", "hot", "top"],
    blurb: "Three rib tanks.",
  },
  {
    id: "bx-01",
    sku: "BX-01",
    name: "Boxers, 3-pack",
    price: 16,
    image: "images/bx-01.svg",
    genders: ["male", "female"],
    collection: "underwear",
    tags: ["boxers", "underwear", "briefs", "pack", "3 pack", "basics"],
    blurb: "Three-pack boxer shorts.",
  },
  {
    id: "sk-01",
    sku: "SK-01",
    name: "Socks, 3-pack",
    price: 12,
    image: "images/sk-01.svg",
    genders: ["male", "female"],
    collection: "underwear",
    tags: ["socks", "crew", "pack", "3 pack", "basics", "footwear"],
    blurb: "Crew socks, three pair.",
  },
  {
    id: "ab-01",
    sku: "AB-01",
    name: "Combat boot",
    price: 90,
    image: "images/ab-01.svg",
    genders: ["male", "female"],
    collection: "footwear",
    tags: ["boots", "combat", "shoes", "footwear", "leather", "lace up"],
    blurb: "Lace-up combat boot.",
  },
];

const ORDER = LOCAL_PRODUCTS.map((p) => p.id);
const TYPE_RULES = [
  [/long[\s-]*sleeve/, "longsleeves"],
  [/hoodie|sweatshirt/, "hoodies"],
  [/outerwear|jacket|windbreaker|coat/, "outerwear"],
  [/underwear|boxer|brief/, "underwear"],
  [/footwear|shoe|boot|sock/, "footwear"],
  [/bottom|pant|short|jean|trouser|jogger|cargo/, "bottoms"],
  [/tank|tee|t[\s-]?shirt|shirt/, "tees"],
];

function collectionFor(type) {
  const value = String(type || "").toLowerCase();
  const match = TYPE_RULES.find(([rule]) => rule.test(value));
  return match ? match[1] : "all";
}

function gendersFor(tags) {
  const list = [];
  if (tags.includes("male")) list.push("male");
  if (tags.includes("female")) list.push("female");
  return list.length ? list : ["male", "female"];
}

function normalizeProduct(raw) {
  const tags = Array.isArray(raw.tags) ? raw.tags : [];
  return {
    id: raw.id,
    sku: raw.sku,
    name: raw.name,
    price: Number(raw.price) || 0,
    image: raw.image || "",
    genders: gendersFor(tags),
    collection: collectionFor(raw.type),
    tags,
    blurb: raw.blurb || "",
    descriptionHtml: raw.descriptionHtml || "",
    variants: raw.variants || {},
  };
}

function sortProducts(list) {
  return list.slice().sort((a, b) => {
    const ai = ORDER.indexOf(a.id);
    const bi = ORDER.indexOf(b.id);
    return (ai < 0 ? 999 : ai) - (bi < 0 ? 999 : bi);
  });
}

function fromAjaxProduct(product) {
  const variants = {};
  (product.variants || []).forEach((variant) => {
    const size = variant.option1 || variant.title;
    if (size && !variants[size]) variants[size] = variant.id;
  });
  const prices = (product.variants || []).map((variant) => Number(variant.price)).filter((n) => !Number.isNaN(n));
  const handle = product.handle;
  return normalizeProduct({
    id: handle,
    sku: handle.length <= 8 ? handle.toUpperCase() : product.title.toUpperCase(),
    name: product.title,
    price: prices.length ? Math.min(...prices) : 0,
    image: product.images?.[0]?.src || "",
    type: product.product_type,
    tags: product.tags || [],
    blurb: String(product.body_html || "").replace(/<[^>]*>/g, "").trim(),
    descriptionHtml: product.body_html || "",
    variants,
  });
}

const liveCatalog = JSON.parse(document.getElementById("co-catalog")?.textContent || "[]");
let PRODUCTS = sortProducts(liveCatalog.length ? liveCatalog.map(normalizeProduct) : LOCAL_PRODUCTS);

function catalogSignature(list) {
  return list.map((product) => `${product.id}:${product.collection}:${product.price}`).join("|");
}

async function refreshCatalog() {
  try {
    const response = await fetch("/collections/all/products.json?limit=250");
    if (!response.ok) return;
    const data = await response.json();
    const next = sortProducts((data.products || []).map(fromAjaxProduct));
    if (!next.length || catalogSignature(next) === catalogSignature(PRODUCTS)) return;
    PRODUCTS = next;
    renderHeader();
    renderGrid();
    if (!document.getElementById("search-overlay").classList.contains("hidden")) renderSearch();
    if (!document.getElementById("pdp-overlay").classList.contains("hidden")) renderProduct();
  } catch (error) {
    console.warn(error);
  }
}

const COLLECTIONS = [
  { id: "all", label: "ALL" },
  { id: "tees", label: "TEES" },
  { id: "longsleeves", label: "LONG SLEEVES" },
  { id: "hoodies", label: "HOODIES" },
  { id: "outerwear", label: "OUTERWEAR" },
  { id: "bottoms", label: "BOTTOMS" },
  { id: "underwear", label: "UNDERWEAR" },
  { id: "footwear", label: "FOOTWEAR" },
];

const INTENTS = [
  { match: /rain|wet|storm|weather|wind/, boost: ["wb-01"], note: "Looking for weather protection." },
  { match: /cold|warm|layer|winter|hoodie/, boost: ["hd-03", "ls-03", "sp-06"], note: "Warm layers." },
  { match: /hot|summer|heat|sleeveless/, boost: ["sh-01", "tt-06", "ts-03"], note: "Hot-weather pieces." },
  { match: /pack|3 pack|three|bundle/, boost: ["ts-03", "tt-06", "bx-01", "sk-01"], note: "Multi-packs." },
  { match: /zip|hoodie/, boost: ["hd-03", "wb-01"], note: "Zip pieces." },
  { match: /jean|denim/, boost: ["pt-05"], note: "Denim." },
  { match: /cargo|pocket|utility/, boost: ["pt-04"], note: "Utility bottoms." },
  { match: /jogger|sweat|lounge|comfy|comfort/, boost: ["sp-06", "hd-03"], note: "Loungewear." },
  { match: /shoe|boot|footwear|combat/, boost: ["ab-01"], note: "Footwear." },
  { match: /sock/, boost: ["sk-01"], note: "Socks." },
  { match: /underwear|boxer|brief/, boost: ["bx-01"], note: "Underwear." },
  { match: /short/, boost: ["sh-01"], note: "Shorts." },
  { match: /tee|t-shirt|tshirt|shirt/, boost: ["ts-03", "ls-03"], note: "Shirts." },
  { match: /tank|vest/, boost: ["tt-06"], note: "Tanks." },
];

const SYNONYMS = {
  tshirt: "tee",
  "t-shirt": "tee",
  shirts: "shirt",
  tees: "tee",
  hoodies: "hoodie",
  jumper: "hoodie",
  pullover: "hoodie",
  trousers: "pants",
  pant: "pants",
  denim: "jeans",
  kicks: "shoes",
  sneaker: "shoes",
  trainers: "shoes",
  jacket: "windbreaker",
  coat: "windbreaker",
  men: "male",
  mens: "male",
  man: "male",
  women: "female",
  womens: "female",
  woman: "female",
  girl: "female",
  guy: "male",
};

const SIZES = ["XS", "S", "M", "L", "XL"];
const COLS = [1, 2, 3];

const state = {
  gender: "male",
  cols: 2,
  collection: "all",
  cat: "all",
  query: "",
  cart: [],
  page: "shop",
  product: null,
  size: "M",
  collectionsOpen: false,
};

async function refreshCart() {
  const cart = await fetch("/cart.js").then((r) => r.json());
  state.cart = cart.items.map((item) => ({
    key: item.key,
    sku: (item.handle || item.title || "").toUpperCase(),
    image: item.image || "",
    price: item.price / 100,
    size: item.variant_title,
    qty: item.quantity,
  }));
  renderHeader();
  if (document.getElementById("cart-drawer").classList.contains("open")) renderCart();
}

async function changeLine(key, quantity) {
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id: key, quantity }),
  });
  await refreshCart();
}

function money(n) {
  return `$${n.toFixed(2)}`;
}

function tokenize(q) {
  return q
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .map((t) => SYNONYMS[t] || t);
}

function levenshtein(a, b) {
  if (a === b) return 0;
  const m = [];
  for (let i = 0; i <= b.length; i++) m[i] = [i];
  for (let j = 0; j <= a.length; j++) m[0][j] = j;
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      m[i][j] =
        b.charAt(i - 1) === a.charAt(j - 1)
          ? m[i - 1][j - 1]
          : Math.min(m[i - 1][j - 1] + 1, m[i][j - 1] + 1, m[i - 1][j] + 1);
    }
  }
  return m[b.length][a.length];
}

function fuzzyHas(hay, needle) {
  if (hay.includes(needle)) return true;
  return hay.split(/[\s,]+/).some((w) => w.length > 2 && levenshtein(w, needle) <= 1);
}

function intelligentSearch(query, pool) {
  const q = query.trim();
  if (!q) return { items: pool, note: "" };
  const tokens = tokenize(q);
  const intents = INTENTS.filter((i) => i.match.test(q.toLowerCase()));
  const note = intents[0]?.note || "Matching names, SKUs, and similar pieces.";

  const scored = pool.map((p) => {
    const hay = `${p.sku} ${p.name} ${p.tags.join(" ")} ${p.blurb} ${p.collection}`.toLowerCase();
    let score = 0;
    if (p.sku.toLowerCase() === q.toLowerCase()) score += 80;
    if (hay.includes(q.toLowerCase())) score += 40;
    tokens.forEach((t) => {
      if (t.length < 2) return;
      if (p.sku.toLowerCase().includes(t)) score += 30;
      if (fuzzyHas(hay, t)) score += 12;
    });
    intents.forEach((i) => {
      if (i.boost.includes(p.id)) score += 28;
    });
    if (tokens.includes("male") && p.genders.includes("male")) score += 8;
    if (tokens.includes("female") && p.genders.includes("female")) score += 8;
    return { p, score };
  });

  const items = scored
    .filter((s) => s.score > 0)
    .sort((a, b) => b.score - a.score)
    .map((s) => s.p);
  return { items, note };
}

function visibleProducts() {
  return PRODUCTS.filter((p) => {
    if (!p.genders.includes(state.gender)) return false;
    if (state.collection !== "all" && p.collection !== state.collection) return false;
    return true;
  });
}

function cartCount() {
  return state.cart.reduce((n, i) => n + i.qty, 0);
}

function cartTotal() {
  return state.cart.reduce((n, i) => n + i.price * i.qty, 0);
}

function toast(msg) {
  const el = document.getElementById("toast");
  el.textContent = msg;
  el.classList.add("show");
  setTimeout(() => el.classList.remove("show"), 1600);
}

function renderHeader() {
  document.querySelectorAll(".gender-btn").forEach((b) => {
    b.classList.toggle("active", b.dataset.gender === state.gender);
  });
  const count = cartCount();
  const badge = document.getElementById("cart-count");
  badge.textContent = count;
  badge.classList.toggle("hidden", count === 0);
}

function renderGrid() {
  const grid = document.getElementById("grid");
  grid.className = `grid cols-${state.cols}`;
  const items = visibleProducts();
  if (!items.length) {
    grid.innerHTML = "";
    document.getElementById("empty").classList.remove("hidden");
    return;
  }
  document.getElementById("empty").classList.add("hidden");
  grid.innerHTML = items
    .map(
      (p) => `
      <article class="card" data-open="${p.id}">
        <div class="card-img"><img src="${p.image}" alt="${p.sku}"></div>
        <h2>${p.sku}</h2>
        <p class="card-price">${money(p.price)}</p>
      </article>`
    )
    .join("");
}

function renderCollections() {
  const panel = document.getElementById("collections-panel");
  panel.classList.toggle("open", state.collectionsOpen);
  panel.querySelectorAll("[data-collection]").forEach((b) => {
    b.classList.toggle("active", b.dataset.collection === state.collection);
  });
  document.querySelectorAll(".cat").forEach((c) => {
    c.classList.toggle("active", c.dataset.cat === state.cat);
  });
}

function openOverlay(id) {
  document.querySelectorAll(".overlay").forEach((o) => o.classList.add("hidden"));
  document.getElementById(id).classList.remove("hidden");
  if (id === "search-overlay") {
    const input = document.getElementById("search-input");
    input.value = state.query;
    renderSearch();
    setTimeout(() => input.focus(), 50);
  }
}

function closeOverlays() {
  document.querySelectorAll(".overlay").forEach((o) => o.classList.add("hidden"));
  document.getElementById("cart-drawer").classList.remove("open");
}

function renderSearch() {
  const { items, note } = intelligentSearch(state.query, PRODUCTS);
  document.getElementById("search-hint").textContent = state.query
    ? note
    : "Try “rain jacket”, “3 pack tees”, “HD-03”, or “something warm”.";
  const box = document.getElementById("search-results");
  if (!state.query) {
    box.innerHTML = PRODUCTS.map(
      (p) => `
      <div class="search-row" data-open="${p.id}">
        <img src="${p.image}" alt="">
        <div><strong>${p.sku}</strong><span>${p.name}</span></div>
        <span>${money(p.price)}</span>
      </div>`
    ).join("");
    return;
  }
  if (!items.length) {
    box.innerHTML = `<p class="empty">No matches. Try a SKU, a vibe, or a garment type.</p>`;
    return;
  }
  box.innerHTML = items
    .map(
      (p) => `
      <div class="search-row" data-open="${p.id}">
        <img src="${p.image}" alt="">
        <div><strong>${p.sku}</strong><span>${p.name}</span></div>
        <span>${money(p.price)}</span>
      </div>`
    )
    .join("");
}

function sizesFor(p) {
  const keys = p?.variants ? Object.keys(p.variants) : [];
  return keys.length ? keys : SIZES;
}

function renderProduct() {
  const p = PRODUCTS.find((x) => x.id === state.product);
  if (!p) return;
  const sizes = sizesFor(p);
  if (!sizes.includes(state.size)) state.size = sizes.includes("M") ? "M" : sizes[0];
  document.getElementById("pdp-body").innerHTML = `
    <img class="pdp-img" src="${p.image}" alt="${p.sku}">
    <h1>${p.sku}</h1>
    <p class="pdp-meta">${p.name} · ${money(p.price)}</p>
    <div class="sizes">
      ${sizes.map(
        (s) => `<button class="size ${s === state.size ? "active" : ""}" data-size="${s}">${s}</button>`
      ).join("")}
    </div>
    <button class="submit" id="add-to-cart">ADD TO CART</button>
    <div class="page-copy" id="pdp-copy"></div>
  `;
  const copy = document.getElementById("pdp-copy");
  if (p.descriptionHtml) copy.innerHTML = p.descriptionHtml;
  else copy.textContent = p.blurb || "";
}

function renderCart() {
  const body = document.getElementById("cart-body");
  if (!state.cart.length) {
    body.innerHTML = `<h1 style="letter-spacing:.2em;font-weight:400;font-size:14px;margin:40px 0">YOUR CART IS EMPTY</h1>`;
    document.getElementById("cart-foot").classList.add("hidden");
    return;
  }
  document.getElementById("cart-foot").classList.remove("hidden");
  body.innerHTML = state.cart
    .map(
      (i, idx) => `
      <div class="cart-item">
        <img src="${i.image}" alt="">
        <div>
          <strong>${i.sku}</strong>
          <div>${i.size} · ${money(i.price)}</div>
          <div class="qty">
            <button data-qty="${idx}" data-d="-1">−</button>
            <span>${i.qty}</span>
            <button data-qty="${idx}" data-d="1">+</button>
          </div>
        </div>
        <button data-remove="${idx}">✕</button>
      </div>`
    )
    .join("");
  document.getElementById("cart-total").textContent = money(cartTotal());
}

async function addToCart(p, size) {
  const id = p.variants && p.variants[size];
  if (!id) {
    toast("That size is not available");
    return;
  }
  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id, quantity: 1 }),
  });
  if (!res.ok) {
    toast("Couldn't add that piece");
    return;
  }
  await refreshCart();
  toast(`${p.sku} added`);
}

function closeMenu() {
  const menu = document.getElementById("nav-menu");
  const btn = document.getElementById("menu-btn");
  if (!menu || !btn) return;
  menu.classList.add("hidden");
  btn.setAttribute("aria-expanded", "false");
}

document.addEventListener("click", (e) => {
  const menuBtn = e.target.closest("#menu-btn");
  if (menuBtn) {
    const menu = document.getElementById("nav-menu");
    const open = menu.classList.toggle("hidden") === false;
    menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
    return;
  }

  const menuItem = e.target.closest("[data-menu]");
  if (menuItem) {
    closeMenu();
    const action = menuItem.dataset.menu;
    if (action === "collections") {
      state.collectionsOpen = true;
      renderCollections();
      document.getElementById("shop-collections").scrollIntoView({ behavior: "smooth", block: "center" });
    } else if (action === "contact") openOverlay("contact-overlay");
    else if (action === "info") openOverlay("info-overlay");
    else if (action === "vip") openOverlay("vip-overlay");
    return;
  }

  if (!e.target.closest(".header-left")) closeMenu();

  const plus = e.target.closest("#plus-btn");
  if (plus) {
    const i = COLS.indexOf(state.cols);
    state.cols = COLS[(i + 1) % COLS.length];
    renderGrid();
    plus.setAttribute("aria-label", `Grid ${state.cols} across`);
    return;
  }

  const gender = e.target.closest(".gender-btn");
  if (gender) {
    state.gender = gender.dataset.gender;
    renderHeader();
    renderGrid();
    return;
  }

  const cat = e.target.closest(".cat");
  if (cat) {
    state.collection = cat.dataset.cat;
    state.cat = cat.dataset.cat;
    renderCollections();
    renderGrid();
    return;
  }

  const open = e.target.closest("[data-open]");
  if (open) {
    state.product = open.dataset.open;
    state.size = "M";
    closeOverlays();
    openOverlay("pdp-overlay");
    renderProduct();
    return;
  }

  if (e.target.closest("#search-btn")) {
    openOverlay("search-overlay");
    return;
  }
  if (e.target.closest("#cart-btn")) {
    document.getElementById("cart-drawer").classList.add("open");
    renderCart();
    return;
  }
  if (e.target.closest(".close-x") || e.target.closest(".drawer-bg")) {
    closeOverlays();
    return;
  }

  if (e.target.closest("#shop-collections")) {
    state.collectionsOpen = !state.collectionsOpen;
    renderCollections();
    return;
  }
  const col = e.target.closest("[data-collection]");
  if (col) {
    state.collection = col.dataset.collection;
    state.cat = ["tees", "longsleeves", "hoodies", "bottoms"].includes(col.dataset.collection)
      ? col.dataset.collection
      : "all";
    renderCollections();
    renderGrid();
    return;
  }

  if (e.target.closest("#contact-btn")) openOverlay("contact-overlay");
  if (e.target.closest("#info-btn")) openOverlay("info-overlay");
  if (e.target.closest("#vip-btn")) openOverlay("vip-overlay");

  const size = e.target.closest("[data-size]");
  if (size) {
    state.size = size.dataset.size;
    renderProduct();
    return;
  }
  if (e.target.closest("#add-to-cart")) {
    const p = PRODUCTS.find((x) => x.id === state.product);
    addToCart(p, state.size);
    return;
  }

  const qty = e.target.closest("[data-qty]");
  if (qty) {
    const idx = Number(qty.dataset.qty);
    const line = state.cart[idx];
    changeLine(line.key, line.qty + Number(qty.dataset.d));
    return;
  }
  const rm = e.target.closest("[data-remove]");
  if (rm) {
    changeLine(state.cart[Number(rm.dataset.remove)].key, 0);
  }
});

document.getElementById("search-input").addEventListener("input", (e) => {
  state.query = e.target.value;
  renderSearch();
});

renderHeader();
renderCollections();
renderGrid();
refreshCart();
refreshCatalog();
setInterval(refreshCatalog, 30000);
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") refreshCatalog();
});

const shopRoot = document.getElementById("shop-app");
if (shopRoot?.dataset.product) {
  state.product = shopRoot.dataset.product;
  state.size = "M";
  openOverlay("pdp-overlay");
  renderProduct();
}
if (shopRoot?.dataset.openCart === "true") {
  document.getElementById("cart-drawer").classList.add("open");
  renderCart();
}
if (document.getElementById("contact-success")) openOverlay("contact-overlay");
if (document.getElementById("vip-success")) openOverlay("vip-overlay");
